import React from 'react';
import Card from '../UI/Card';
import { CONFIG } from '../../config';

/**
 * Services Section Component
 * 
 * Showcases the core competencies and services offered.
 * Renders a grid of cards based on the configuration data.
 */
const Services = () => {
    return (
        <section className="py-20 px-6 sm:px-10">
            <div className="max-w-7xl mx-auto">
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">Core Competencies</h2>
                    <p className="text-slate-600 dark:text-slate-400 max-w-2xl">
                        Specialized in building robust enterprise solutions with modern technologies.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {CONFIG.services.map((service) => {
                        const Icon = service.icon;
                        return (
                            <Card key={service.id} className="flex flex-col h-full">
                                <div className="w-12 h-12 bg-purple-100 dark:bg-purple-500/10 rounded-xl flex items-center justify-center text-purple-600 dark:text-purple-400 mb-6 group-hover:bg-purple-500 group-hover:text-white transition-colors duration-300">
                                    <Icon size={24} />
                                </div>
                                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{service.title}</h3>
                                <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                                    {service.description}
                                </p>
                            </Card>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Services;
